/* eslint complexity: off */

import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import type { UiState } from 'instantsearch.js';
import { SITE_INDEX_HE } from 'assets/constants';

type RouteState = {
  query?: string;
  typeOfObject?: string | undefined | null;
};

const routeStateDefaultValues: RouteState = {
  query: '',
  typeOfObject: null,  
};

const router = historyRouter<RouteState>({

  createURL({ qsModule, routeState, location }): string {
    const { protocol, hostname, port = '', pathname, hash } = location;
    const portWithPrefix = port === '' ? '' : `:${port}`;
    const baseUrl = `${protocol}//${hostname}${portWithPrefix}${pathname}`;

    const queryParameters: Partial<RouteState> = {};
    if (
      routeState.query &&
      routeState.query !== routeStateDefaultValues.query
    ) {
      queryParameters.query = encodeURIComponent(routeState.query);
    }
    if (
      routeState.typeOfObject &&
      routeState.typeOfObject !== routeStateDefaultValues.typeOfObject
    ) {
      queryParameters.typeOfObject = routeState.typeOfObject;
    }

    const queryString = qsModule.stringify(queryParameters, {
      addQueryPrefix: true,
      arrayFormat: 'repeat',
    });

    return `${baseUrl}${queryString}${hash}`;
  },

  parseURL({ qsModule, location }): RouteState {
    const queryParameters = qsModule.parse(location.search.slice(1));
    const {
      query = '',
      typeOfObject = null,
    } = queryParameters;

    return {
      query: decodeURIComponent(query as string),     
      typeOfObject: typeOfObject as string | null,
    };
  },
});

const getStateMapping = ({ indexName }: { indexName: string}) => ({
  stateToRoute(uiState: UiState): RouteState {
    return {
      query: uiState[indexName].query,
      typeOfObject: (uiState[indexName].menu && uiState[indexName].menu?.objectType) || undefined,
    };
  },

  routeToState(routeState: RouteState): UiState {
    const menuRefinement: { [key: string]: string } = {};
    if (routeState.typeOfObject) {
      menuRefinement['objectType'] = routeState.typeOfObject;
    }
      return {
        [SITE_INDEX_HE]: {
          query: routeState.query,
          menu: menuRefinement ? menuRefinement : undefined,
        }
    }
  },
});

const getRouting = (indexName: string) => ({
  router,
  stateMapping: getStateMapping({ indexName }),
});

export default getRouting;


